import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import type { FC } from "react";
import { Trans } from "react-i18next";

export const RemoveConfirmationDialog: FC<{
  type: "logo" | "color";
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}> = ({ type, open, onClose, onDelete }) => {
  return (
    <Dialog
      open={open}
      onClose={(e: MouseEvent) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Trans>
          You’re about to remove a {type}. It will no longer be available for use in any draft or
          future designs. Sent Communications will be unaffected.
        </Trans>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={1}>
          <Button
            data-analytics-id="brand-kit-remove-dialog-cancel"
            variant="outlined"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            data-analytics-id="brand-kit-remove-dialog-confirm"
            variant="contained"
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
              onClose();
            }}
          >
            Yes, delete
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
